import api from 'service/api'

const dponetAPI = api.create('guestPortal')

const list = async (params) => {
  return await dponetAPI.get('/ai_inventories', { params })
}

const show = async (aiInventoryId) => {
  // detailed=true → serializer completo (finalidades, modo, intervenção, risco,
  // dados pessoais), igual à listagem. Sem isso o refresh incremental do painel
  // sobrescreve o card com o serializer enxuto e some com as informações.
  return await dponetAPI.get(`/ai_inventories/${aiInventoryId}`, {
    params: { detailed: true },
  })
}

const create = async (data) => {
  return await dponetAPI.post('/ai_inventories', { aiInventory: data })
}

const update = async (aiInventoryId, data) => {
  return await dponetAPI.put(`/ai_inventories/${aiInventoryId}`, {
    aiInventory: data,
  })
}

const updateRiskAnalysis = async (aiInventoryId, data) =>
  dponetAPI.patch(`/ai_inventories/${aiInventoryId}/risk_analysis`, {
    aiInventory: data,
  })

const confirmVeracity = async (aiInventoryItemIds) =>
  dponetAPI.post('/ai_inventories/confirm_veracity', { aiInventoryItemIds })

export default {
  list,
  show,
  create,
  update,
  updateRiskAnalysis,
  confirmVeracity,
}
